import { mergeDeep } from '@/helpers/utils'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => {
	const extensionSchema: Partial<LandingScreenSchema>[] = [
		// [0] loader-water-balance-f, [1] age-main — order must match landing.ids
		{
			components: {
				LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
					title: $t('japanese_water_fasting.landing.loader_title'),
					size: 'large',
					uppercase: true,
				}),
			},
		},
		{
			components: {
				LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
					title: $t('japanese_water_fasting.landing.age_title'),
					size: 'large',
				}),
			},
		},
	]

	return mergeDeep([...schemas], extensionSchema)
}
